import * as React from 'react'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import { styled } from '@mui/material/styles'
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { setTypeTooltip } from '../../redux/slices/common'
import { isEmpty } from '../../utils'

interface Props extends TooltipProps {
  header?: string
  type: string
}

const TooltipClick = (props: Props) => {
  const isArrow = props.arrow
  const LightTooltip = styled(({ className, ...tooltipProps }: TooltipProps) => (
    <Tooltip {...tooltipProps} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
      '&::before': {
        backgroundColor: theme.palette.common.black,
        border: '1px solid black',
      },
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: isArrow ? theme.palette.common.black : theme.palette.common.white,
      boxShadow: isArrow ? '0px 4px 4px rgba(0, 0, 0, 0.25)' : '0px 6px 24px rgba(0, 0, 0, 0.16)',
      borderRadius: isArrow ? 8 : 24,
      padding: isArrow ? '12px 16px' : 24,
      maxWidth: 'initial',
    },
  }))
  const dispatch = useAppDispatch()
  const { typeTooltip } = useAppSelector((state) => state.common)

  const handleClose = () => {
    dispatch(setTypeTooltip(''))
  }

  const handleOpen = () => {
    dispatch(setTypeTooltip(props.type))
  }

  const title = props.header ? (
    <div className="dtravel-inter-500">
      <div
        // style={{ width: 'calc(100% + 48px)' }}
        className="dtravel-center-horizontal dtravel-flex-between border-b border-b-neutral-300 mb-6 pb-6 "
      >
        <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M3.52876 3.52851C3.78911 3.26816 4.21122 3.26816 4.47157 3.52851L8.00016 7.05711L11.5288 3.52851C11.7891 3.26816 12.2112 3.26816 12.4716 3.52851C12.7319 3.78886 12.7319 4.21097 12.4716 4.47132L8.94297 7.99992L12.4716 11.5285C12.7319 11.7889 12.7319 12.211 12.4716 12.4713C12.2112 12.7317 11.7891 12.7317 11.5288 12.4713L8.00016 8.94273L4.47157 12.4713C4.21122 12.7317 3.78911 12.7317 3.52876 12.4713C3.26841 12.211 3.26841 11.7889 3.52876 11.5285L7.05735 7.99992L3.52876 4.47132C3.26841 4.21097 3.26841 3.78886 3.52876 3.52851Z"
            fill="#3D3D3D"
          />
        </svg>

        <span className="dtravel-text-16-20 dtravel-neutral-800 mx-10 whitespace-nowrap dtravel-inter-500">{props.header}</span>
        <div className="w-4 h-4" />
      </div>
      {props.title}
    </div>
  ) : (
    <div>{props.title}</div>
  )
  const open = !isEmpty(typeTooltip) && typeTooltip === props?.type
  const isDateOfBirth = props?.type === 'dateOfBirth'
  return (
    <div>
      <ClickAwayListener onClickAway={handleClose}>
        <div className="flex items-start">
          <LightTooltip
            PopperProps={{ disablePortal: !isDateOfBirth }}
            onClose={handleClose}
            open={open}
            disableFocusListener
            disableHoverListener={props?.disableHoverListener}
            disableTouchListener
            title={title}
            arrow={props.arrow}
            placement={props.placement || 'bottom-start'}
          >
            {/* eslint-disable-next-line*/}
            <div
              onClick={(e: any) => {
                handleOpen()
                e.stopPropagation()
              }}
              onMouseOver={() => {
                if (!open && !props?.disableHoverListener) handleOpen()
              }}
              onMouseLeave={() => {
                if (open && !props?.disableHoverListener) handleOpen()
              }}
              className={`w-auto flex items-start underline cursor-pointer ${open ? 'text-ocean-800' : 'dtravel-neutral-600'
                }`}
            >
              {props.children}
            </div>
          </LightTooltip>
        </div>
      </ClickAwayListener>
    </div>
  )
}
export default TooltipClick
